import { defineStore } from "pinia";

import { COUNTRIES_FILTER_QUERY } from "@/api/enforcement/countries.ts";
import { GET_RETAILERS_LIST, GET_NETSUITE_LOCATION_IDS } from "@/api/retailers/index.js";
import { apollo } from "@/utils/apollo.ts";

interface NetSuiteLocation {
  id: string
  fullname: string
  name: string
}

interface State {
  all: {
    retailer_id: string
    name: string
    short_name: string
    created_at: string
    updated_at: string
    deleted_at: string | null
    __typename: string
    media: {
      file_path: string
    }
  }[]
  netsuiteLocations: NetSuiteLocation[]
}

export const useRetailersStore = defineStore("retailers", {
  state: (): State => ({
    all: [],
    netsuiteLocations: [],
  }),

  getters: {
    getNetsuiteLocations: (state) => state.netsuiteLocations,
  },

  actions: {
    async fetchActiveRetailers() {
      try {
        const { data } = await apollo.query({
          query: GET_RETAILERS_LIST,
          variables: {
            status: "active",
          },
        });
        this.all = data.retailers;
      }
      catch (error) {
        console.error(error);
      }
    },

    async fetchNetsuiteLocations() {
      try {
        const { data } = await apollo.query({
          query: GET_NETSUITE_LOCATION_IDS,
        });
        this.netsuiteLocations = data.netSuiteLocationIds || [];
      }
      catch (error) {
        console.error("Failed to fetch NetSuite locations:", error);
      }
    },
  },
});
